// ----------------------------------------------------------------------
// <copyright file="Izenda.LicenseCheckerStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * License Checker Store
 */
!(function () {

  var m = require('mobx');
  var databaseSetupDataFetcher = require('fetchers/Izenda.DatabaseSetupDataFetcher');
  var systemSettingFetcher = require('fetchers/Izenda.SystemSettingFetcher');
  var uiState = require('./Izenda.UiState');

  var DatabaseConfiguration = require('./models/Izenda.DatabaseConfiguration');
  var SystemModeSetting = require('logic/models/Izenda.SystemModeSetting');

  function LicenseCheckerStore() {
    this.databaseConfiguration = new DatabaseConfiguration();
    this.licenseInfoStore = require('./Izenda.LicenseInfoStore');
    this.systemModeSetting = new SystemModeSetting();

    m.observe(this.databaseConfiguration, function (change) {

      var connectionStatus = change.object;

      if (change.name === 'isValidConnection') {

          if (connectionStatus.isValidConnection) {
            this.licenseInfoStore.getLicenseInformation();
            this.licenseInfoStore.getLicenseStatus();
          } else {
            this.licenseInfoStore.licenseInfo.resetLicenseInfo();
          }

      }
    }.bind(this));
  }

  /**
   * Get init data (connection string)
   */
  LicenseCheckerStore.prototype.getInitData = function () {
    return Promise.all(this.getConnectionInfo(), this.loadSystemSetting());
  }

  /**
   * get suppported database type
   */
  LicenseCheckerStore.prototype.getSupportedDatabaseType = function () {
    return databaseSetupDataFetcher.getSupportedDatabaseType()
      .then(function (response) {
        this.databaseConfiguration.updateSupportedDatabaseType(response);
      }.bind(this));
  }

  /**
   * Test connection string
   * @param {string} serverType
   * @param {string} connectionString
   */
  LicenseCheckerStore.prototype.testConnection = function () {
    var connectionInfo = this.databaseConfiguration.connectionInfo;

    return databaseSetupDataFetcher.testConnection(connectionInfo.serverTypeId, connectionInfo.connectionString)
      .then(function (response) {
      response = response || {};

      this.databaseConfiguration.readTestConnectionStatus(response);

        return response.messages;
    }.bind(this));
  };

  /**
   * Setup Data base after test connection successfully
   * @param {string} serverType
   * @param {string} connectionString
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.setupDatabase = function (resetDataInfo) {
    var connectionInfo = this.databaseConfiguration.connectionInfo;
    //reset dataInfo
    resetDataInfo && this.databaseConfiguration.resetDataInfo();
    return databaseSetupDataFetcher.setupDatabase(connectionInfo.serverTypeId, connectionInfo.connectionString)
      .then(function (response) {
        this.databaseConfiguration.setValidConnection(response);
        if (response.success){
          this.licenseInfoStore.getLicenseInformation();
          this.licenseInfoStore.getLicenseStatus();
          uiState.increaseDetectChangeVisibleConnection();
          uiState.increaseDetectChangeCount();
        }
      return response;
    }.bind(this));
  };


  /**
   * Get connection info
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.getConnectionInfo = function () {

    return databaseSetupDataFetcher.getConnectionInfo()
      .then(function (response) {

        this.databaseConfiguration.updateConnectionInfo(response);

        return null;
      }.bind(this));
  };

  /**
   * Save System Setting mode
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.saveSystemSetting = m.action(function (data) {
    return systemSettingFetcher.saveSystemModeSettings(data)
           .then(m.action(function (result) {
             result.success && (uiState.systemMode = data.systemMode)
             return result;
           }));
  });

  /**
   * Load System Setting mode
   * @returns {promise}
   */
  LicenseCheckerStore.prototype.loadSystemSetting = function () {
    return systemSettingFetcher.loadSystemModeSettings()
           .then(this.systemModeSetting.readSystemModeSetting.bind(this.systemModeSetting));
  };

  module.exports = LicenseCheckerStore;
}());



// WEBPACK FOOTER //
// ./ui/logic/Izenda.LicenseCheckerStore.js